import axios from "axios";

export const api = axios.create({
  //baseURL:"https://66d1-179-242-244-189.sa.ngrok.io/v1"
 ///baseURL: "https://clarear.fci.inf.br/api"
  baseURL: "https://clarear.fci.inf.br/api/public/v1",
 //baseURL: "https://clarear.fci.inf.br/api/v1",

});